import Wallet from "./wallet.page";

export default Wallet;
